// initial state
const state = {
	comment: '',
	score: null,
	cashMoney: null,
}

// mutations
const mutations = {
	saveCommentInfo(state, payload) {
	state.comment = payload.comment
	},
	clearCommentInfo(state) {
	state.comment = ''
	},

	saveScoreInfo(state, value) {
	state.score = value;
	},
	clearScoreInfo(state) {
	state.score = null;
	},

	saveCashMoneyInfo(state, value) {
		state.cashMoney = value;
	},
	clearCashMoneyInfo(state) {
		state.cashMoney = null;
	},
}

export default {
  state,
  mutations
}
